import * as React from 'react'

const VideoClip = ({
  title,
  titleId,
  ...props
}: {
  title?: string
  titleId?: string
} & React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="#400099"
    focusable={false}
    aria-hidden
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M2.146 18.292V7.799a.75.75 0 01.75-.75h18.208a.75.75 0 01.75.75v10.493c0 .965-.787 1.75-1.755 1.75H3.901a1.752 1.752 0 01-1.755-1.75zm1.5-9.743v9.743c0 .137.113.25.255.25h16.198c.14 0 .255-.115.255-.25V8.549H3.646zm10.422 5.201l-2.893-1.973v3.946l2.893-1.973zM9.825 17v-6.5a.675.675 0 011.055-.558l4.767 3.25a.675.675 0 010 1.116l-4.767 3.25A.675.675 0 019.825 17zm-6.93-8.424a.75.75 0 01-.75-.75V5.778c0-.963.789-1.747 1.756-1.747h16.198c.968 0 1.755.781 1.755 1.747v2.048a.75.75 0 01-.75.75H2.896zm17.46-1.5V5.778a.251.251 0 00-.256-.247H3.901a.253.253 0 00-.255.247v1.298h16.708zM14.811 5.39a.75.75 0 111.5 0V7.5a.75.75 0 11-1.5 0V5.389zm-7.124 0a.75.75 0 011.5 0V7.5a.75.75 0 01-1.5 0V5.389z" />
  </svg>
)

export default VideoClip
